// TableSkeleton.jsx
// Simple Tailwind-based table skeleton loader
// Props:
// - rows (number) default 6
// - cols (number) default 4
// - showHeader (boolean) default true
// Usage: <TableSkeleton rows={5} cols={3} showHeader={true} />

export default function TableSkeleton({ rows = 6, cols = 4, showHeader = true }) {
  const headerCells = Array.from({ length: cols });
  const bodyRows = Array.from({ length: rows });

  return (
    <div className="w-full">
      <div className="overflow-auto rounded border">
        <table className="min-w-full table-auto">
          {showHeader && (
            <thead className="bg-gray-50">
              <tr>
                {headerCells.map((_, i) => (
                  <th key={i} className="px-4 py-3 text-left">
                    <div className="h-4 w-32 animate-pulse rounded bg-gray-200" />
                  </th>
                ))}
                <th className="px-4 py-3" />
              </tr>
            </thead>
          )}

          <tbody>
            {bodyRows.map((_, rIdx) => (
              <tr key={rIdx} className="odd:bg-white even:bg-gray-50">
                {headerCells.map((_, cIdx) => (
                  <td key={cIdx} className="px-4 py-3">
                    <div className="h-4 w-full animate-pulse rounded bg-gray-200" />
                  </td>
                ))}
                <td className="px-4 py-3">
                  <div className="h-4 w-16 animate-pulse rounded bg-gray-200" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
